import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=9acc6df0&scoped=true&"
import script from "./EditTaskModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=9acc6df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acc6df0",
  null
  
)

export default component.exports